<template>
  <div class="foot-con">
    <div class="footer-main">
        <div class="footer-column brand-column">
            <div class="footer-logo">
                <span class="logo-text">GRAVITY</span>
                <span class="logo-sub">SHOP</span>
            </div>
            <p class="brand-motto">The ultimate destination for premium global shopping. Experience the gravity of quality.</p>
        </div>
        
        <div class="footer-column">
            <h4 class="column-title">Contact</h4>
            <div class="consult-btn" @click="openLiveChat">
                <i class="el-icon-headset"></i> Contact Live Support
            </div>
        </div>
        
        <div class="footer-divider"></div>
        
        <div class="footer-social-group">
            <div class="social-item">
                <div class="social-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zm-1.292 19.482h2.039L6.486 3.24H4.298l13.311 17.395z" fill="currentColor"/>
                    </svg>
                </div>
                <span class="social-label">Follow us on X</span>
            </div>
            <div class="social-item">
                <div class="social-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                    </svg>
                </div>
                <span class="social-label">Instagram</span>
            </div>
        </div>
    </div>
    
    <div class="footer-bottom">
        <div class="copyright">
            <span>&copy; {{ new Date().getFullYear() }} GRAVITY SHOP. All Rights Reserved.</span>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'v-foot',
        props: {
            obj: Object
        },
        data () {
            return {
            }
        },
        watch: {
            obj: {
                handler (nVal) {
                    if (!nVal || !nVal.componentContent) return
                    var data = nVal.componentContent.publicList
                    if (!data) return
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].title === '客服电话') { this.phone = data[i].des }
                        if (data[i].title === '营业时间') { this.time = data[i].des }
                        if (data[i].title === '微信公众号') {
                            this.img1.des = data[i].des
                            this.img1.pic = data[i].pic
                        }
                        if (data[i].title === '小程序码') {
                            this.img2.des = data[i].des
                            this.img2.pic = data[i].pic
                        }
                    }
                }
            }
        },
        methods: {
            openLiveChat () {
                if (window.$chatway) {
                    window.$chatway.openChatwayWidget()
                } else {
                    this.$message.info('Live support is loading, please try again in a moment...')
                }
            }
        }
    }
</script>

<style scoped lang="scss">
@import "../../styles/variables.scss";

.foot-con {
    background-color: $gray-900;
    color: $white;
    padding: 80px 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .footer-main {
        max-width: 1200px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 40px;
        margin-bottom: 60px;
    }
}

.brand-column {
    flex: 1.5;
    .footer-logo {
        margin-bottom: 20px;
        .logo-text {
            font-size: 28px;
            font-weight: 900;
            color: $white;
            letter-spacing: 2px;
        }
        .logo-sub {
            font-size: 28px;
            font-weight: 300;
            color: $primary-color;
            margin-left: 5px;
        }
    }
    .brand-motto {
        font-size: 15px;
        color: rgba($white, 0.5);
        line-height: 1.8;
        max-width: 300px;
    }
}

.footer-column {
    flex: 1;
    min-width: 150px;
    .column-title {
        font-size: 18px;
        color: $white;
        margin-bottom: 25px;
        font-weight: 600;
        position: relative;
        padding-bottom: 10px;
        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30px;
            height: 2px;
            background: $primary-color;
        }
    }
    
    .footer-links {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
            font-size: 14px;
            color: rgba($white, 0.4);
            margin-bottom: 12px;
            cursor: pointer;
            transition: $transition-fast;
            &:hover {
                color: $white;
                padding-left: 5px;
            }
        }
    }
    
    .consult-btn {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 12px 24px;
        border: 1px solid rgba($white, 0.2);
        border-radius: $border-radius-md;
        font-size: 15px;
        cursor: pointer;
        transition: $transition-fast;
        color: $white;
        
        &:hover {
            border-color: $white;
            background-color: rgba($white, 0.05);
            transform: translateY(-2px);
        }
    }
}

.footer-divider {
    display: none; // No longer needed for multi-column layout
}

.footer-social-group {
    display: flex;
    gap: 30px;
    flex: 1;
    justify-content: flex-end;
    
    .social-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        cursor: pointer;
        transition: $transition-fast;

        &:hover {
            color: $primary-color;
            .social-icon {
                background: rgba($white, 0.1);
                border-color: $primary-color;
                transform: translateY(-5px);
            }
        }
        
        .social-icon {
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba($white, 0.05);
            border: 1px solid rgba($white, 0.1);
            border-radius: 50%;
            color: $white;
            transition: all 0.3s ease;
            
            svg {
                width: 24px;
                height: 24px;
            }
        }
        
        .social-label {
            font-size: 14px;
            color: rgba($white, 0.5);
            font-weight: 500;
        }
    }
}

.footer-bottom {
    width: 100%;
    max-width: 1200px;
    padding-top: 40px;
    border-top: 1px solid rgba($white, 0.05);
    text-align: center;
    
    .copyright {
        font-size: 13px;
        color: rgba($white, 0.3);
        display: flex;
        flex-direction: column;
        gap: 8px;
        
        .beian {
            &:hover {
                color: rgba($white, 0.5);
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/v-foot.vue